export const Role = {
    Admin: 'Admin',
    User: 'User',
    CS2PlusUsers: 'DB_WEB_CS2PLUS_USERS'
}